export default __webpack_public_path__ + "static/media/applicationsIcon.4f5d6f4b.svg";